import React from "react"
import {useAccessToken} from "../../../services/auth"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {patchProductApplicationOfficer} from "../../../resources/productApplication"
import ConfirmationModalContent from "../../ReevaluateApplication/ReevaluateConfirmationModal/ConfirmationModalContent"
import {ReevaluatedOfficerApplicationData} from "../../ReevaluateApplication/Forms/ReevaluateOfficerForm/ReevaluateOfficerForm"

export default function ReevaluateProductApplicationOfficerConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	productApplicationId: string
	officerId: string
	reevaluatedData: ReevaluatedOfficerApplicationData
}) {
	const {close, onSuccess, productApplicationId, officerId, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateRequest, setUpdateRequest] = useAsyncResultIdle(patchProductApplicationOfficer)

	const handleSubmit = (reason: string) => {
		const data = {
			fullName: reevaluatedData.fullName,
			address: reevaluatedData.address,
			dateOfBirth: reevaluatedData.dateOfBirth,
			email: reevaluatedData.email,
			phone: reevaluatedData.phone,
			ssn: reevaluatedData.ssn,
			passport: reevaluatedData.passport,
			nationality: reevaluatedData.nationality,
			matriculaConsular: reevaluatedData.matriculaConsular,
			occupation: reevaluatedData.occupation,
			annualIncome: reevaluatedData.annualIncome,
			sourceOfIncome: reevaluatedData.sourceOfIncome,
		}

		setUpdateRequest(accessToken, productApplicationId, officerId, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={true}
		/>
	)
}
